import React from "react";
import {getToken_qqcatalyst_token} from "./types/getToken";

export interface OAuthState {
    token?: getToken_qqcatalyst_token;
    setToken: (token: getToken_qqcatalyst_token) => void;
}

export const OAuthContext = React.createContext<OAuthState>({} as any);

export default class OAuthProvider extends React.Component<React.PropsWithChildren<{}>, OAuthState> {

    setToken = (token: getToken_qqcatalyst_token) => this.setState({...this.state, token});

    state: OAuthState = {
        setToken: this.setToken
    };

    render() {
        return <OAuthContext.Provider value={this.state}>
            {this.props.children}
        </OAuthContext.Provider>;
    }
}
